// @flow
import type { Saga } from "redux-saga";
import { call } from "redux-saga/effects";
import { makeApiCall } from "redux/middleware/api";
import { BIZHUB_API_ENDPOINTS } from "redux/modules/createCabelasClass/constants";
import type { BusinessLocationRecord } from "redux/modules/createCabelasClass/records/BusinessLocationRecord";
import { parseInstructorLocations } from "./instructorLocations";

export function* loadInstructorLocations(
  businessId?: string
): Saga<Array<BusinessLocationRecord>> {
  const businessFilter =
    businessId === undefined
      ? ""
      : `businessId=${encodeURIComponent(businessId)}&`;
  const locationsById = new Map<string, BusinessLocationRecord>();
  let page = 1;
  let totalPages = 1;

  do {
    const json = yield call(
      makeApiCall,
      "GET",
      `${BIZHUB_API_ENDPOINTS.INSTRUCTOR_LOCATIONS}?${businessFilter}perPage=50&page=${page}`,
      undefined,
      false
    );
    const locations = parseInstructorLocations(json, businessId);
    locations.forEach((location: BusinessLocationRecord) => {
      locationsById.set(location.locationId, location);
    });
    totalPages = json.meta.totalPages;
    page += 1;
  } while (page <= totalPages);

  return Array.from(locationsById.values());
}
